import axios from "axios";
const URLS = "https://plasticsmartcities.wwf.id/aksi/api";
var TOKEN = sessionStorage.getItem('token');

export default {
   actions: {
      setToken(data){
         TOKEN = data
      },
      get_transaction(limit,key) {
         return new Promise((resolve, reject) => {
            try {
               axios
                  .get(URLS + `/v1/client/my-transactions?limit=1000&sort=${limit}&filter[name]=${key}`, {
                     headers:{
                        Authorization: `Bearer ${TOKEN}`,
                        'Access-Control-Allow-Origin': '*',
                     }
                  })
                  .then((response) => {
                     // console.log(response)
                     resolve(response?.data?.data);
                  }).catch((err) => {
                     reject(err?.response?.data)
                     // console.log('oko', err)
                  });
               } catch (error) {
                  console.log(error);
               }
            });
      },
      get_pickup(status) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .get(URLS + `/v1/client/pickup/requests?filter[status]=${status}`, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     "Content-Type": "application/json",
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      get_partner() {
         return new Promise((resolve, reject) => {
            try {
               axios
               .get(URLS + `/v1/client/partners?filter[name]&sort=name&filter[verification_status]=success`, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      get_partner_filter(key) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .get(URLS + `/v1/client/partners?filter[name]=${key}&sort=name&filter[organization_type]=`, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      get_partner_detail(id) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .get(URLS + `/v1/client/partner/${id}`, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      get_partner_verified(type,op,key) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .get(URLS + `/v1/client/all-partners?sort=name&filter[name]=${key}&filter[verification]=${type}&onlymypartners=${op}`, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                  }
               })
               .then((response) => {
                  resolve(response?.data);
                  console.log(response.data)
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      post_pickup(formData) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .post(URLS + `/v1/client/pickup/request`, formData, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Content-Type' : 'multipart/form-data',
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      post_pickup_status(formData) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .post(URLS + `/v1/client/pickup/update-status`, formData, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Content-Type' : 'multipart/form-data',
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      get_mutation(id) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .get(URLS + `/v1/client/transactions/${id}`, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      get_transaction_history(id, limit,filter, key) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .get(URLS + `/v1/client/transactions/${id}/history?limit=1000&filter=${filter}&sort=${limit}&filter[name]=${key}`, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               console.log(error);
            }
         });
      },
      get_transaction_history_detail(id, slug) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .get(URLS + `/v1/client/transactions/${id}/history/${slug}`, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               console.log(error);
            }
         });
      },
      post_withdraw(formData) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .post(URLS + `/v1/client/withdraw`, formData, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Content-Type' : 'multipart/form-data',
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      get_cart() {
         return new Promise((resolve, reject) => {
            try {
               axios
                  .get(URLS + `/v1/client/deposits`, {
                     headers:{
                        Authorization: `Bearer ${TOKEN}`,
                        'Access-Control-Allow-Origin': '*',
                     }
                  })
                  .then((response) => {
                     resolve(response?.data?.data);
                  }).catch((err) => {
                     reject(err?.response?.data)
                  });
               } catch (error) {
                  console.log(error);
               }
            });
      },
      post_cart(formData) {
         return new Promise((resolve, reject) => {
            try {
               axios
               .post(URLS + `/v1/client/update-status`, formData, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Content-Type' : 'multipart/form-data',
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      post_request_join(data){
         return new Promise((resolve, reject) => {
            try {
               axios
               .post(URLS + `/v1/client/join-partner`, data, {
                  headers:{
                     Authorization: `Bearer ${TOKEN}`,
                     'Content-Type' : 'multipart/form-data',
                     'Access-Control-Allow-Origin': '*',
                  }
               })
               .then((response) => {
                  resolve(response?.data);
               }).catch((err) => {
                  reject(err?.response?.data)
               });
            } catch (error) {
               reject(error);
            }
         });
      },
      get_transaction_download(id) {
         return new Promise((resolve, reject) => {
            try {
               axios
                  .get(URLS + `/v1/client/transactions/${id}/download`, {
                     headers:{
                        Authorization: `Bearer ${TOKEN}`,
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                     },
                     responseType: 'arraybuffer',
                  })
                  .then((response) => {
                     resolve(response?.data);
                  }).catch((err) => {
                     reject(err?.response?.data)
                  });
               } catch (error) {
                  console.log(error);
               }
            });
      },
   },
};


